<script setup lang="ts">
import { computed } from "vue";
import { tw } from "../../lib/utils";

const { enabled = true, reverse } = defineProps<{
	enabled?: boolean;
	reverse?: boolean;
}>();

const enter = computed(() => (reverse ? tw`-translate-x-full` : tw`translate-x-full`));
const leave = computed(() => (reverse ? tw`translate-x-full` : tw`-translate-x-full`));
</script>

<template>
	<Transition
		:css="enabled"
		enterActiveClass="transition duration-300 ease-out"
		:enterFromClass="`transform ${enter}`"
		enterToClass="transform translate-x-0"
		leaveActiveClass="absolute top-0 w-full transition duration-300 ease-out"
		leaveFromClass="transform translate-x-0"
		:leaveToClass="`transform ${leave}`"
	>
		<slot />
	</Transition>
</template>
